import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Icons } from "../../../icons/Icons";
import { IconContainer, SideBarContainer } from "./styles";
import { useToastStore } from "../../../stores/toastStore";
import {
  isNavigationItemActive,
  NavigationItem,
  useSidebarItems,
} from "../../../config/navigationConfig";

export const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarItems = useSidebarItems();
  const showToast = useToastStore((state) => state.showToast);
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const handleItemClick = (item: NavigationItem) => {
    if (!item.hasPermission) {
      showToast({
        type: "error",
        title: "NO CUENTAS CON PERMISOS PARA ACCEDER A ESTA SECCIÓN",
      });
      return;
    }

    if (!item.released) {
      showToast({
        type: "info",
        title: `PRÓXIMAMENTE: ${item.modalLabel ?? item.id}`,
      });
      return;
    }

    navigate(item.route);
  };

  return (
    <SideBarContainer
      aria-label="Navegación principal"
      data-testid="desktop-sidebar"
    >
      {sidebarItems.map((item) => {
        const isSelected = isNavigationItemActive(location.pathname, item);
        const isDisabled = !item.released || !item.hasPermission;
        const itemClasses = [
          "sidebar-item",
          isSelected ? "selected" : "",
          isDisabled ? "disabled" : "",
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <IconContainer
            key={item.id}
            type="button"
            className={itemClasses}
            onClick={() => handleItemClick(item)}
            aria-disabled={isDisabled}
            aria-label={item.name}
            aria-current={isSelected ? "page" : undefined}
            onMouseEnter={() => setHoveredItem(item.id)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <Icons
              name={item.icon}
              height={32}
              width={32}
              isHovered={
                (hoveredItem === item.id || isSelected) && !isDisabled
              }
            />
          </IconContainer>
        );
      })}
    </SideBarContainer>
  );
};
